import React from 'react'
import Header from '../Header/Header'
import GanadoresData from '../../Components/Admin/GanadoresData/GanadoresData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Ganadores() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <GanadoresData />
                </div>
            </section>
        </div>
    )
}

